<template>
  <settings-modal
    class="payment-charge-type-change-modal t-payment-charge-type-change-modal"
  >
    <template slot="heading">Change fees coverage</template>
    <template>
      <v-radio-group
        v-model="form.transferChargeType"
        class="mt-0"
        label="Select type"
        persistent-hint
        :error-messages="getValidationErrorMessage('transferChargeType')"
      >
        <v-radio
          v-for="type in transferChargeTypes"
          :key="type"
          :class="`t-charge-type-${type.toLowerCase()}`"
          :label="type"
          :value="type"
          color="primary"
        />
      </v-radio-group>
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="isConfirmButtonDisabled"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Constants
  import { TRANSFER_CHARGE_TYPES } from '@/models/Payment'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentTransferChargeTypeChangeModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { transferChargeType: null },
        requiredFields: ['transferChargeType'],
        updateTransferChargeTypeApiRequest: new ApiRequest(PaymentApi.updateTransferChargeTypeByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      isConfirmButtonDisabled () {
        return this.updateTransferChargeTypeApiRequest.loading || !this.isFormFilled || this.form.transferChargeType === this.currentTransferChargeType
      },
      paymentId () {
        return this.modal.data.paymentId
      },
      currentTransferChargeType () {
        return this.modal.data.transferChargeType
      },
      transferChargeTypes () {
        return Object.values(TRANSFER_CHARGE_TYPES)
      },
      error () {
        return this.updateTransferChargeTypeApiRequest.error
      }
    },
    created () {
      this.setFieldValue('transferChargeType', this.currentTransferChargeType)
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.updateTransferChargeTypeApiRequest.execute(this.paymentId, this.parsedFormInput.transferChargeType)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)

            this.showModal({
              name: 'SuccessFlashModal',
              data: {
                message: 'Fees coverage type has been successfully updated.'
              }
            })
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
